import React from 'react'

import PropTypes from 'prop-types'

import { Box, Typography } from '@mui/material'

import AttachmentCard from '~/src/UI/Cards/Attachment'
import { parseCommentText } from '~/src/UI/Shared/DescriptionMentions'

import Base from './Base'
import { getFirstAttachment, renderCommentStatus } from './utils'

export const formatNote = dataToFormat => {
  const {
    annotation: { title, description, comments = [] }
  } = dataToFormat
  let status = null

  if (comments.length) {
    status = [renderCommentStatus(comments)]
  }

  return {
    title,
    body: description,
    status,
  }
}

export const NoteFormatter = React.memo(({
  annotation: { attachment: attachments, title, description, comments },
  inline,
  tooltip,
  transparentCard,
  ...props
}) => {
  const attachment = getFirstAttachment(attachments)
  const renderedTitle = comments.length ? (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="nowrap"
      style={{ gap: '8px' }}
    >
      <Typography variant="inherit" noWrap>
        {title}
      </Typography>
      {renderCommentStatus(comments)}
    </Box>
  ) : title
  let formattedDescription = description || ''
  if (typeof description === 'string') {
    formattedDescription = parseCommentText(formattedDescription)
  }
  return (
    <Base
      {...props}
      inline={inline}
      title={(!inline && attachment) ? null : renderedTitle}
      body={(!inline && attachment) ? (
        <AttachmentCard
          {...attachment}
          title={renderedTitle}
          description={formattedDescription}
          inline={inline}
          tooltip={tooltip}
          transparent={transparentCard}
        />
      ) : formattedDescription}
    />
  )
})

NoteFormatter.propTypes = {
  annotation: PropTypes.shape({
    attachment: PropTypes.arrayOf(PropTypes.shape({
      filename: PropTypes.string,
      mimetype: PropTypes.string.isRequired,
      title: PropTypes.string,
      url: PropTypes.string.isRequired,
    })),
    description: PropTypes.string,
    descriptionMentions: PropTypes.arrayOf(PropTypes.number),
    comments: PropTypes.arrayOf(PropTypes.shape),
    title: PropTypes.string.isRequired,
  }).isRequired,
  inline: PropTypes.bool,
  tooltip: PropTypes.bool,
  transparentCard: PropTypes.bool,
}

NoteFormatter.defaultProps = {
  inline: false,
  tooltip: true,
  transparentCard: false,
}

NoteFormatter.displayName = 'Annotatation/Note'

export default React.memo(NoteFormatter)
